import { Injectable } from '@angular/core';
import { element } from '@angular/core/src/render3/instructions';

@Injectable({
  providedIn: 'root'
})
export class GetloadingService {
  private maskCounter: number = 0;

  constructor() {
    this.maskCounter = 0;
  }

  /**
   * loading 动画控制方法
   * @param text 弃用
   * @param openMask 是否打开 loading 动画 （只有值为 true 时有意义）
   * @param closeMask 是否关闭 loading 动画 （只有 openMask 是 true 时有意义）
   */
  public getMask(text: string, openMask: boolean, closeMask: boolean = false): void {
    if (closeMask) {
      this.maskCounter -= 1;
      if (this.maskCounter > 0) {
        return;
      }
      document.body.style.overflow = '';
      const getLoad = document.getElementsByClassName('loader')[0];
      if (getLoad === undefined) {
        return;
      }
      getLoad.parentNode.removeChild(getLoad);
    } else if (openMask) {
      this.maskCounter += 1;
      document.body.style.overflow = 'hidden';
      const getEl = document.getElementsByClassName('loader');
      if (getEl.length < 1) {
        document.body.style.overflow = 'hidden';
        const loadDiv = document.createElement('div');

        loadDiv.className = 'loader';

        document.body.appendChild(loadDiv);
      }
    }
  }

  public isMaskEngage() {
    const getEl = document.getElementsByClassName('loader');
    if (getEl.length < 1) {
      return false;
    }
    else {
      return true;
    }
  }

}
